<button (click)="close()" class="close-button" matTooltip="Close">
  <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title *ngIf="data.title">{{ data.title }}</h2>

<mat-dialog-content>
  <div class="content" [innerHTML]="data.content"></div>
  <div class="dont-show-again" *ngIf="data.dontShowAgain">
    <mat-checkbox [(ngModel)]="dontShowAgain">Don't show this again</mat-checkbox>
  </div>
</mat-dialog-content>

<ng-container *ngIf="data.showOkButton === true">
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="close(data.okButtonText ?? 'Ok')">
      {{ data.okButtonText ?? "Ok" }}
    </button>
  </mat-dialog-actions>
</ng-container>
